import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { Pressable, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import EmojiAddIcon from '@atlaskit/icon/glyph/emoji-add';

/**
 * Test id for the tooltip
 */
export var RENDER_TOOLTIP_TRIGGER_TESTID = 'render-tooltip-trigger';
export var RENDER_TRIGGER_BUTTON_TESTID = 'render-trigger-button';
var triggerStyles = xcss({
  minWidth: '32px',
  height: '24px',
  padding: 'space.0',
  borderWidth: 'border.width',
  borderStyle: 'solid',
  borderRadius: 'border.radius.circle',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  lineHeight: '16px'
});
var transparentEnabledTriggerStyles = xcss({
  borderColor: 'color.border',
  backgroundColor: 'color.background.neutral.subtle',
  ':hover': {
    backgroundColor: 'color.background.neutral.subtle.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.neutral.subtle.pressed'
  }
});
var opaqueEnabledTriggerStyles = xcss({
  borderColor: 'color.border',
  backgroundColor: 'elevation.surface',
  ':hover': {
    backgroundColor: 'elevation.surface.hovered'
  },
  ':active': {
    backgroundColor: 'elevation.surface.pressed'
  }
});
var disabledTriggerStyles = xcss({
  borderColor: 'color.border.disabled',
  backgroundColor: 'color.background.disabled'
});
var miniModeStyles = xcss({
  minWidth: '24px',
  padding: 'space.050',
  border: 'none',
  borderRadius: 'border.radius'
});

/**
 * Render an emoji button to open the reactions select picker
 */
export var Trigger = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var onClick = props.onClick,
    miniMode = props.miniMode,
    tooltipContent = props.tooltipContent,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$ariaAttributes = props.ariaAttributes,
    ariaAttributes = _props$ariaAttributes === void 0 ? {} : _props$ariaAttributes,
    _props$showOpaqueBack = props.showOpaqueBackground,
    showOpaqueBackground = _props$showOpaqueBack === void 0 ? false : _props$showOpaqueBack;
  var handleMouseDown = function handleMouseDown(e, analyticsEvent) {
    if (onClick && !disabled) {
      onClick(e, analyticsEvent);
    }
  };
  return jsx(Tooltip, {
    testId: RENDER_TOOLTIP_TRIGGER_TESTID,
    content: tooltipContent
  }, jsx(Pressable, _extends({
    testId: RENDER_TRIGGER_BUTTON_TESTID,
    xcss: [triggerStyles, disabled ? disabledTriggerStyles : showOpaqueBackground ? opaqueEnabledTriggerStyles : transparentEnabledTriggerStyles, miniMode && miniModeStyles],
    onClick: handleMouseDown,
    isDisabled: disabled,
    ref: ref
  }, ariaAttributes), jsx(EmojiAddIcon, {
    primaryColor: disabled ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)",
    size: "small",
    label: "Add reaction"
  })));
});